/**
 * LogoIcon Component
 * 
 * The icon/symbol portion of the MyVitae logo (document/page icon).
 * Can be used standalone or as part of the full Logo component.
 * 
 * Usage:
 *   import { LogoIcon } from '../design-system/brand';
 *   <LogoIcon className="w-8 h-8" color="#60a5fa" />
 */
import React from "react";

const LogoIcon = ({ className = "w-8 h-8", color = "#60a5fa", useCurrentColor = false }) => {
  const strokeColor = useCurrentColor ? "currentColor" : color;
  
  return (
    <svg className={className} viewBox="0 0 100 100" fill="none">
      {/* Main page body - outline only */}
      <path 
        d="M20 15 L20 85 L80 85 L80 35 L60 15 Z" 
        fill="none"
        stroke={strokeColor} 
        strokeWidth="6"
        strokeLinejoin="round"
      />
      {/* Folded corner - outline only */}
      <path 
        d="M60 15 L60 35 L80 35" 
        fill="none"
        stroke={strokeColor} 
        strokeWidth="6"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default LogoIcon;
